import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import Button from '@/components/Button';
import Dialog, {
	DialogContent,
	DialogFooter,
	DialogTop
} from '@/components/Dialog';
import { useShallowEqualSelector } from '@/hooks';
import Delete from '@/icons/delete-user.svg';
import {
	setDeleteCollaboratorModal,
	setSelectedCollaborator
} from '@/store/collaborators';
import { deleteCollaborator } from '@/store/collaborators/thunks';
import { showError, showSuccess } from '@/utils';

function DeleteCollaboratorModal() {
	const dispatch = useDispatch();
	const { t } = useTranslation();

	const { isOpen, selectedCollaborator } = useShallowEqualSelector(
		({ collaborators }) => ({
			isOpen: collaborators.deleteCollaboratorModalOpen,
			isLoading: collaborators.loading,
			selectedCollaborator: collaborators.selectedCollaborator
		})
	);

	const onClose = () => {
		dispatch(setDeleteCollaboratorModal(false));
		dispatch(setSelectedCollaborator(null));
	};

	const handleDeleteCollaborator = async id => {
		dispatch(deleteCollaborator(id))
			.unwrap()
			.then(() => {
				showSuccess(t('users.deleteUserModal.success'));
				onClose();
			})
			.catch(error => {
				showError(error);
			})
			.finally(() => {
				dispatch(setDeleteCollaboratorModal(false));
				dispatch(setSelectedCollaborator(null));
			});
	};

	return (
		<Dialog open={isOpen} onOpenChange={onClose}>
			<DialogContent className="w-[280px] md:w-[397px]">
				<DialogTop title={t('users.deleteUserModal.title')} />

				<div className="inline-flex flex-col items-center justify-center gap-2 self-stretch overflow-hidden px-4 py-9">
					<Delete />
					<div className="w-[249px] justify-center text-center text-sm leading-normal text-grey-500">
						{t('users.deleteUserModal.description', {
							email: selectedCollaborator?.email
						})}
					</div>
				</div>

				<DialogFooter>
					<Button
						type="button"
						variant="outline"
						onClick={event => {
							event.preventDefault();
							onClose(false);
						}}
					>
						{t('common.cancel')}
					</Button>
					<Button
						type="submit"
						loading={false}
						onClick={() =>
							handleDeleteCollaborator(selectedCollaborator?.id)
						}
					>
						{t('common.delete')}
					</Button>
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
}

export default DeleteCollaboratorModal;
